import { memo, useCallback } from 'react'

import { Divider } from '@mui/material'
import { OrgEnvironment } from '@nativewaves/nw-cloud-sdk/org'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemCopyId, MenuItemDelete } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useRecentEnvironment } from 'domains/_Sidebar'
import { useEnvironmentDeleteMutation } from 'hooks/mutations/org'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<OrgEnvironment>) => {
  const { t } = useTranslation(['common', 'entity', 'domain'])
  const { enqueueSnackbar } = useSnackbar()

  const [recentEnvironment, setRecentEnvironment] = useRecentEnvironment()

  const { mutate: deleteOrgEnvironment } = useEnvironmentDeleteMutation()

  const handleDeleteOrgEnvironment = useCallback(() => {
    onClose()

    deleteOrgEnvironment(
      { environmentId: row.original.id },
      {
        onSuccess: () => {
          if (row.original.id === recentEnvironment) {
            setRecentEnvironment(undefined)
          }
          enqueueSnackbar(t('domain:My.Organization.nameDelete', { name: row.original.name }), { variant: 'success' })
        },
      },
    )
  }, [
    deleteOrgEnvironment,
    enqueueSnackbar,
    onClose,
    recentEnvironment,
    row.original.id,
    row.original.name,
    setRecentEnvironment,
    t,
  ])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider sx={{ my: 1 }} component="li" />
      <MenuItemDelete onConfirm={handleDeleteOrgEnvironment} />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
